import StrokeCounts from "./StrokeCounts";
export default function LetterComparator (guess, targetWord){

    var result = Array.from({length: guess.length}, () => "");

    const strokeCounts = StrokeCounts();

    function resultsObject (resultState, remainingOptions){
        return {
            "resultState": resultState,
            "remainingOptions": remainingOptions
        };
    }

    let guessLetters = guess.toUpperCase().split('');
    let targetLetters = targetWord.toUpperCase().split('');

    result = guessLetters.map((letter, index) => {
        var remainingOptions = [];
        let targetLetter = targetLetters[index];
        if(letter === targetLetter)
        {
            return resultsObject('exactMatch', remainingOptions);
        }

        let guessStraight = strokeCounts[letter].straight;
        let guessCurve = strokeCounts[letter].curve;

        let targetStraight = strokeCounts[targetLetter].straight;
        let targetCurve = strokeCounts[targetLetter].curve;

        if (guessStraight === targetStraight && guessCurve === targetCurve){
            for (const [checkLetter, strokes] of Object.entries(strokeCounts)) {
                if(checkLetter === letter){
                    continue;
                }
                if (strokes.straight == targetStraight && strokes.curve == targetCurve){     
                    remainingOptions.push(checkLetter);          
                }
            }
            return resultsObject('typeMatch', remainingOptions);
        }
        let guessTotal = guessStraight + guessCurve;
        let targetTotal = targetStraight + targetCurve;

        if (guessTotal === targetTotal){
            for (const [checkLetter, strokes] of Object.entries(strokeCounts)) {      
                if(checkLetter === letter){
                    continue;
                }
                if (strokes.straight === guessStraight && strokes.curve === guessCurve){
                    continue;
                }
                if (strokes.straight + strokes.curve == guessTotal){
                    remainingOptions.push(checkLetter);      
                }
            }
            return resultsObject('countMatch', remainingOptions);
        }
        return resultsObject('noMatch', remainingOptions);
    });

    return result;
}

